import { collection, doc, getCountFromServer, getDoc, setDoc } from 'firebase/firestore';
import { db } from './firebase';

// Crea/aggiorna il documento dell'utente in users/{uid} a ogni login — un
// solo documento per persona (l'id è lo uid), quindi "Utenti registrati"
// nella Home è semplicemente il conteggio dei documenti in questa collection.
export async function recordUserLogin(user) {
  if (!user?.uid) return;
  await setDoc(
    doc(db, 'users', user.uid),
    {
      email: user.email || '',
      displayName: user.displayName || '',
      lastLoginAt: Date.now(),
    },
    { merge: true }
  );
}

export async function getTotalUsersCount() {
  const snap = await getCountFromServer(collection(db, 'users'));
  return snap.data().count;
}

// Nome da mostrare come "host" per contenuti pubblici di un altro utente
// (strategie pubbliche, ecc.): il documento users/{uid} è leggibile da
// chiunque sia autenticato (vedi firestore.rules), quindi displayName/email
// di un altro utente sono normalmente disponibili qui.
function pickDisplayName(data) {
  const name = String(data?.displayName || '').trim();
  if (name) return name;
  const email = String(data?.email || '').trim();
  if (email) return email.split('@')[0];
  return 'Utente';
}

// Risolve più uid in un colpo solo (deduplicati) — pensato per liste di
// contenuti pubblici con proprietari diversi (es. registro strategie
// pubbliche), dove altrimenti si farebbe una getDoc per ogni riga anche a
// fronte di pochi host distinti.
// Nome della categoria/etichetta "Personalizzata": scelto liberamente da ogni
// utente (account-level, riusato in tutte le sue strategie/aste finché non lo
// cambia) — vedi StrategyEditPage.js, AuctionMarketTab.js, AuctionUnavailableTab.js.
// Il documento users/{uid} è leggibile da chiunque sia autenticato (serve a
// mostrare l'etichetta anche a chi guarda una strategia condivisa/pubblica),
// ma scrivibile solo dal proprietario (vedi firestore.rules).
export const DEFAULT_CUSTOM_CATEGORY_LABEL = 'Personalizzata';

export async function getCustomCategoryLabel(uid) {
  if (!uid) return DEFAULT_CUSTOM_CATEGORY_LABEL;
  try {
    const snap = await getDoc(doc(db, 'users', uid));
    const stored = String(snap.exists() ? snap.data()?.customCategoryLabel || '' : '').trim();
    return stored || DEFAULT_CUSTOM_CATEGORY_LABEL;
  } catch {
    return DEFAULT_CUSTOM_CATEGORY_LABEL;
  }
}

export async function setCustomCategoryLabel(uid, label) {
  const normalized = String(label || '').trim();
  if (!uid || !normalized) return false;
  await setDoc(doc(db, 'users', uid), { customCategoryLabel: normalized, updatedAt: Date.now() }, { merge: true });
  return true;
}

export async function getUserDisplayNamesByIds(uids = []) {
  const uniqueIds = Array.from(new Set((uids || []).filter(Boolean).map(String)));
  const result = {};
  await Promise.all(
    uniqueIds.map(async (uid) => {
      try {
        const snap = await getDoc(doc(db, 'users', uid));
        result[uid] = snap.exists() ? pickDisplayName(snap.data()) : 'Utente';
      } catch {
        result[uid] = 'Utente';
      }
    })
  );
  return result;
}
